<div class="mobilemenu" [ngClass]="{'mobilemenu--open': isOpen}">
    <div class="mobilemenu__backdrop" (click)="mobilemenu.close()"></div>
    <div class="mobilemenu__body">
        <div class="mobilemenu__header">
            <a class="mobile-header__logo" href="http://www.home-connect.co.za/">
                <img height="30px" width="100px" src="../../../../../assets/images/megamenu/Main_logo.png" alt="">
            </a>
            <div class="mobilemenu__title"></div>
            <button type="button" style="color: #fff;" class="mobilemenu__close" (click)="mobilemenu.close()">
                <app-icon name="cross-20" size="20"></app-icon>
            </button>
        </div>
        <div class="mobilemenu__content"  style="color: #fff;" >
            <app-mobile-links [links]="links"(itemClick)="onItemClick($event)"></app-mobile-links>
            <ul class="account-menu__links" style="cursor: pointer;">
                <!-- <li><a (click)="onLogout($event)">Logout</a></li> -->
            </ul>

        </div>
    </div>
</div>
